<template>
	<!-- <sidenav :style="cssProps" :orientation="orientation" :class="curClasses"> -->
    <sidenav :orientation="orientation" :class="curClasses">

		<!-- Brand demo (see src/demo.css) -->
		<div class="app-brand demo" v-if="orientation !== 'horizontal'" style="height: 66px;">
			<router-link to="/" class="app-brand-logo">
				<img :src="user.brand_logo">
			</router-link>
			<router-link to="/" id="app-brand-acronym" class="app-brand-text demo sidenav-text font-weight-normal ml-2" style="font-size: 1.1rem;" :title="brandNameShort">{{ brandNameShort }}</router-link>
			<a href="javascript:void(0)" class="layout-sidenav-toggle sidenav-link text-large ml-auto" @click="toggleSidenav()">
				<i class="fa fa-bars align-middle"></i>
			</a>
		</div>
		<div class="sidenav-divider mt-0" v-if="orientation !== 'horizontal'"></div>

		<!-- Inner -->
		<div class="sidenav-inner" :class="{ 'pt-1': orientation !== 'horizontal' }" style="padding-bottom: 150px !important;">

			<sidenav-router-link icon="fa fa-dashboard" to="/" :exact="true">{{ __('general.dashboard') }}</sidenav-router-link>
			<li class="sidenav-divider mb-1"></li>

			<template v-if="this.$store.state.user.subcontractor_id && this.$root.hasSubPermission('Manage Pre-Qualification')">
				<sidenav-router-link icon="fa fa-check-square" to="/subcontractors/qualification/edit">Pre-Qualification</sidenav-router-link>
				<sidenav-router-link icon="fa fa-id-badge" to="/subcontractors/view">View Pre-Qualification</sidenav-router-link>
			</template>
			<template>
				<template v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.view.own', 'incidents.view.osha', 'incidents.view.trend'])">
					<sidenav-menu icon="fa fa-stethoscope" :active="isMenuActive('/incidents')" :open="isMenuOpen('/incidents')">
						<template slot="link-text">{{ __('incidents.label_plural') }}</template>
						<sidenav-router-link to="/incidents" :exact="true" v-if="this.$root.hasPermission(['incidents.view.browse', 'incidents.view.own'])">{{ __('incidents.label_plural') }} List</sidenav-router-link>
						<sidenav-router-link to="/incidents/trend" :exact="true" v-if="this.$root.hasPermission('incidents.view.trend')">{{ __('incidents.trend') }}</sidenav-router-link>
						<sidenav-router-link to="/incidents/osha" :exact="true" v-if="this.$root.hasPermission('incidents.view.osha')">OSHA</sidenav-router-link>
						<sidenav-router-link to="/incidents/root-cause" :exact="true" v-if="this.$root.hasPermission('incidents.view.trend')">{{ __('incidents.root_cause') }}</sidenav-router-link>
						<sidenav-router-link to="/incidents/settings" v-if="this.$store.state.user.is_admin"><i class="fa fa-cogs"></i> {{ __('general.settings') }}</sidenav-router-link>
					</sidenav-menu>
				</template>

				<sidenav-router-link icon="fa fa-folder-open" to="/osha" v-if="false && this.$root.hasPermission('incidents.view.browse')">OSHA Data</sidenav-router-link>

				<template v-if="this.$root.hasPermission(['inspections.view.browse', 'inspections.view.own'])">
					<sidenav-router-link v-if="inspectionFilters.length == 0" icon="fa fa-list" to="/inspections">Inspections</sidenav-router-link>
					<sidenav-menu v-else icon="fa fa-list" :active="isMenuActive('/inspections')" :open="isMenuOpen('/inspections')">
						<template slot="link-text">Inspections</template>
						<sidenav-router-link to="/inspections" :exact="true">Inspection List</sidenav-router-link>
						<div class="sidenav-header small font-weight-semibold">Saved Filters</div>
						<sidenav-router-link v-for="(filter, i) in inspectionFilters" :key="i" :to="`/inspections?filter_id=${filter.id}`" :exact="true">
							{{ filter.filter_name }}
						</sidenav-router-link>
					</sidenav-menu>
					<sidenav-router-link icon="fa fa-comment-o" to="/observations">Observations</sidenav-router-link>
				</template>

				<!-- <sidenav-router-link icon="fa fa-address-book-o" to="/clients" v-if="this.$root.hasPermission('clients.view')"> Clients</sidenav-router-link> -->

				<sidenav-router-link icon="fa fa-building" to="/jobsites" v-if="this.$root.hasPermission('jobsites.view')">Jobsites</sidenav-router-link>

				<sidenav-router-link icon="fa fa-shield" to="/hse" v-if="this.$store.state.user.enable_module_mic && this.$root.hasPermission(['hse.view.browse', 'hse.create', 'hse.manage'])">MIC</sidenav-router-link>

				<sidenav-router-link icon="fa fa-files-o" to="/jsa" v-if="this.$root.hasPermission(['jsa.view.browse', 'jsa.view.own'])" :exact="isJsaActive()">JSA</sidenav-router-link>

				<sidenav-router-link icon="fa fa-folder-o" to="/drive" v-if="this.$root.hasPermission('drive.view')">Drive</sidenav-router-link>

				<sidenav-menu icon="fa fa-group" v-if="this.$root.hasPermission(['employees.view', 'recognitions.view', 'employees.disciplinary.view'])" :active="isMenuActive('/employees')" :open="isMenuOpen('/employees')">
					<template slot="link-text">Employees</template>
					<sidenav-router-link v-if="this.$root.hasPermission('employees.view')" to="/employees" :exact="true">Employees</sidenav-router-link>
					<sidenav-router-link v-if="this.$root.hasPermission('recognitions.view')" to="/employees/recognition-list" :exact="true">Recognitions</sidenav-router-link>
					<sidenav-router-link v-if="this.$root.hasPermission('employees.disciplinary.view')" to="/employees/disciplinary-actions" :exact="true">Disciplinary</sidenav-router-link>
					<sidenav-router-link v-if="this.$root.hasPermission('employees.manage')" to="/employees/settings" :exact="true"><i class="fa fa-cogs"></i> Settings</sidenav-router-link>
				</sidenav-menu>

				<sidenav-router-link icon="fa fa-truck" to="/equipment" v-if="this.$root.hasPermission('equipment.view')">Equipment</sidenav-router-link>

				<template v-if="this.$root.hasPermission(['correctiveActions.view.browse', 'correctiveActions.view.assigned'])">
					<sidenav-router-link icon="fa fa-wrench" to="/corrective-actions">Corrective Actions</sidenav-router-link>
				</template>

				<template v-if="this.$root.hasPermission(['safety.meetings.view.browse', 'safety.meetings.view.own'])">
					<sidenav-router-link icon="fa fa-life-ring" to="/safety-meetings">Safety Meetings</sidenav-router-link>
				</template>

				<template v-if="this.$root.hasPermission('safety.data_sheets.view')">
					<sidenav-router-link icon="fa fa-files-o" to="/safety-data-sheets">Safety Data Sheets</sidenav-router-link>
				</template>

				<template v-if="this.$root.hasPermission('subcontractors.view')">
					<sidenav-menu icon="fa fa-id-badge" :active="isMenuActive('/subcontractors')" :open="isMenuOpen('/subcontractors')">
						<template slot="link-text">Subcontractors</template>
						<sidenav-router-link to="/subcontractors" :exact="true"><i class="fa fa-id-badge"></i> Subcontractors</sidenav-router-link>
						<sidenav-router-link to="/subcontractors/approvals" :exact="true" v-if="this.$root.hasPermission('subcontractors.view.approvals')">
							<i class="fa fa-check-square"></i> Approvals
						</sidenav-router-link>
						<sidenav-router-link to="/subcontractors/users" :exact="true" v-if="this.$root.hasPermission('subcontractors.manage')"><i class="fa fa-group"></i> Users</sidenav-router-link>
						<div class="sidenav-item">
							<a href="/subcontractors/map" class="sidenav-link" target="_blank">
								<div><i class="fa fa-globe"></i> Map</div>
							</a>
						</div>
						<sidenav-router-link to="/subcontractors/osha-db" :exact="true"><i class="fa fa-exclamation-triangle"></i> OSHA Data</sidenav-router-link>
						<sidenav-router-link to="/clients" v-if="this.$root.hasPermission('clients.view')"><i class="fa fa-address-book-o"></i> Clients</sidenav-router-link>
						<sidenav-router-link to="/subcontractors/settings" v-if="this.$root.hasPermission('subcontractors.manage')"><i class="fa fa-cogs"></i> Settings</sidenav-router-link>
					</sidenav-menu>
				</template>

				<template v-if="this.$root.hasPermission('training_courses.view')">
					<sidenav-menu icon="fa fa-graduation-cap" :active="isMenuActive('/training-courses')" :open="isMenuOpen('/training-courses')">
						<template slot="link-text">Training Courses</template>
						<sidenav-router-link to="/training-courses" :exact="true">Course List</sidenav-router-link>
						<sidenav-router-link to="/training-courses/completed" :exact="true">Completed Courses</sidenav-router-link>
						<sidenav-router-link to="/training-courses/pending" :exact="true">Pending Courses</sidenav-router-link>
						<sidenav-router-link to="/training-courses/matrix" :exact="true">Matrix</sidenav-router-link>

						<template v-if="this.$root.hasPermission('training_courses.manage')">
							<sidenav-router-link to="/training-courses/alerts">Alerts</sidenav-router-link>
							<sidenav-router-link to="/training-courses/catalogs">Catalogs</sidenav-router-link>
						</template>
					</sidenav-menu>
				</template>

				<template v-if="this.$store.state.user.enable_module_custom_forms && this.$root.hasPermission(['custom_forms.view', 'custom_forms.manage'])">
					<sidenav-router-link icon="fa fa-check-square-o" to="/custom-forms">Custom Forms</sidenav-router-link>
				</template>

				<sidenav-router-link icon="fa fa-user" to="/users" v-if="this.$root.hasPermission(['settings.manage.users', 'settings.view.users'])">Users</sidenav-router-link>

				<sidenav-menu icon="fa fa-bar-chart" v-if="this.$root.hasPermission('reports.view')" :active="isMenuActive('/reports')" :open="isMenuOpen('/reports')">
					<template slot="link-text">Reports</template>

					<sidenav-menu icon="fa fa-stethoscope" :active="isMenuActive('/reports/incidents')" :open="isMenuOpen('/reports/incidents')">
						<template slot="link-text">Incidents</template>
						<sidenav-router-link to="/reports/incidents/chart" :exact="true">
							<i class="fa fa-bar-chart"></i> Chart
						</sidenav-router-link>
						<sidenav-router-link to="/reports/incidents/totals" :exact="true">
							<i class="fa fa-table"></i> Totals
						</sidenav-router-link>
						<sidenav-router-link to="/reports/incidents/root-cause" :exact="true">
							<i class="fa fa-bar-chart"></i> Root Cause
						</sidenav-router-link>
					</sidenav-menu>

					<sidenav-router-link to="/reports/inspection-charts" :exact="true">Inspection Chart</sidenav-router-link>

					<sidenav-router-link to="/reports/non-compliant-items" :exact="true">
						<i class="fa fa-exclamation-triangle"></i> Non-Compliant Items
					</sidenav-router-link>
					<sidenav-router-link to="/reports/inspection-results" :exact="true">
						<i class="fa fa-list"></i> Inspection Results
					</sidenav-router-link>
					<sidenav-router-link to="/reports/correlation-chart" :exact="true">
						<i class="fa fa-line-chart"></i> Correlation Chart
					</sidenav-router-link>
					<sidenav-router-link to="/reports/avg-inspection-score-charts" :exact="true">
						<i class="fa fa-line-chart"></i> Avg Score Charts
					</sidenav-router-link>
					<sidenav-router-link to="/reports/totals-charts" :exact="true">
						<i class="fa fa-dashboard"></i> Totals Chart
					</sidenav-router-link>
				</sidenav-menu>

				<template v-if="this.$store.state.user.is_admin">
					<li class="sidenav-divider mb-1"></li>
					<sidenav-menu icon="fa fa-cogs" :active="isMenuActiveMultiple(['/admin','/inspections/forms', '/jsa/templates'])" :open="isMenuOpenMultiple(['/admin','/inspections/forms', '/jsa/templates'])">
						<template slot="link-text">Admin</template>
						<sidenav-router-link to="/admin/settings">Account Settings</sidenav-router-link>
						<sidenav-router-link to="/admin/api-users" :exact="true">API Users</sidenav-router-link>
                        <sidenav-router-link to="/billing" :exact="true">Billing</sidenav-router-link>
						<sidenav-router-link to="/admin/company-safety-profile" :exact="true">Company Safety Profile</sidenav-router-link>
						<!-- <sidenav-router-link to="/admin/corrective-actions" :exact="true">Corrective Actions</sidenav-router-link> -->
						<!-- <sidenav-router-link to="/admin/disciplinary-violations">Disciplinary Violations</sidenav-router-link> -->
						<sidenav-router-link to="/admin/divisions" :exact="true">Divisions</sidenav-router-link>
						<!-- <sidenav-router-link to="/admin/designations" :exact="true">Designations</sidenav-router-link> -->
						<!-- <sidenav-router-link to="/admin/equipment-types" :exact="true">Equipment Types</sidenav-router-link> -->
						<!-- <sidenav-router-link to="/admin/incident-settings">Incident Settings</sidenav-router-link> -->
						<sidenav-router-link to="/inspections/forms" :exact="true">Inspection Forms</sidenav-router-link>
						<sidenav-router-link to="/jsa/templates" :exact="true">JSA Templates</sidenav-router-link>
						<!-- <sidenav-router-link to="/admin/safety-settings" :exact="true">JSA Hazards &amp; Controls</sidenav-router-link> -->
						<!-- <sidenav-router-link to="/admin/licenses" :exact="true">Licenses</sidenav-router-link> -->
						<!-- <sidenav-router-link to="/admin/body-parts" :exact="true">Major &amp; Specific Body Parts</sidenav-router-link> -->
						<sidenav-router-link to="/admin/hse-types" :exact="true" v-if="this.$store.state.user.enable_module_mic">MIC Types</sidenav-router-link>
						<!-- <sidenav-router-link to="/admin/recognitions" :exact="true">Recognitions</sidenav-router-link> -->
						<!-- <sidenav-router-link to="/admin/roles" :exact="true">Roles &amp; Permissions</sidenav-router-link> -->
						<!-- <sidenav-router-link to="/admin/role-requests" :exact="true">Role Requests</sidenav-router-link> -->
						<!-- <sidenav-router-link to="/admin/subcontractor-settings">Subcontractor Settings</sidenav-router-link> -->
						<!-- <sidenav-router-link to="/admin/root-cause-settings" :exact="true">Root Causes</sidenav-router-link> -->
					</sidenav-menu>
				</template>
				<template v-if="this.$store.state.user.is_admin && this.$store.state.user.is_reseller_account == 1">
					<li class="sidenav-divider mb-1"></li>
					<sidenav-menu icon="fa fa-sitemap" :active="isMenuActive('/dev')" :open="isMenuOpen('/dev')">
						<template slot="link-text">Resellers</template>
						<sidenav-router-link to="/resellers/accounts">Accounts</sidenav-router-link>
					</sidenav-menu>
				</template>
				<template v-if="this.$store.state.user.is_admin && this.$store.state.user.is_dev == 1">
					<li class="sidenav-divider mb-1"></li>
					<sidenav-menu icon="fa fa-key" :active="isMenuActive('/dev')" :open="isMenuOpen('/dev')">
						<template slot="link-text">Developers</template>
                        <!-- <sidenav-router-link to="/billing" :exact="true">Billing</sidenav-router-link> -->
						<sidenav-router-link to="/dev/accounts">Accounts</sidenav-router-link>
						<sidenav-router-link to="/changelogs">Changelogs</sidenav-router-link>
						<a target="_blank" class="sidenav-link" href="/admin/logs">Logs</a>
					</sidenav-menu>
				</template>
			</template>
		</div>
	</sidenav>
</template>

<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'

export default {
	name: 'app-layout-sidenav',
	components: {
		Sidenav,
		SidenavLink,
		SidenavRouterLink,
		SidenavMenu,
		SidenavHeader,
		SidenavBlock,
		SidenavDivider
	},

	props: {
		orientation: {
			type: String,
			default: 'vertical'
		}
	},

	computed: {
		activeBgColor() {
			return this.shadeColor2(this.user.brand_color, .05);
		},

		inactiveTextColor() {
			return this.shadeColor2(this.user.brand_text_color, -.4);
		},

		brandNameShort(){
			let name = 'MeritEHS';

			if(this.$store.state.user.brand_name_short)
			{
				name = this.$store.state.user.brand_name_short;
			}

			//Send it
			return name;
		},

		user() {
			return this.$store.state.user
		},

        // No explanation, but https://github.com/vuejs/vue/issues/7346#issuecomment-366474434 has a codepen that shows this
		cssProps() {
			return {
				'--backgroundColor': this.user.brand_color, // Normal Background
                '--activeBackgroundColor': this.activeBgColor, // Active Background
				'--textColor': this.inactiveTextColor, // Normal Text Color
				'--activeTextColor': this.user.brand_text_color, // Active/Hovered Text Color
				'--noticeColor': '#ff0000', // Something noticeable for any "unused" fields that aren't actually unused
			}
		},

		curClasses () {
			let bg = this.layoutSidenavBg

			if (this.orientation === 'horizontal' && (bg.indexOf(' sidenav-dark') !== -1 || bg.indexOf(' sidenav-light') !== -1)) {
				bg = bg
					.replace(' sidenav-dark', '')
					.replace(' sidenav-light', '')
					.replace('-darker', '')
					.replace('-dark', '')
			}

			return `bg-${bg} ` + (
                this.orientation !== 'horizontal'
                    ? 'layout-sidenav'
                    : 'layout-sidenav-horizontal container-p-x flex-grow-0'
            )
			// return this.orientation !== 'horizontal'
   //                  ? 'sidenav-custom layout-sidenav'
   //                  : 'sidenav-custom layout-sidenav-horizontal container-p-x flex-grow-0'
		},

		incidentFilters(){
			//Setup
			var filters = [];

			//Check the stor
			if(this.$store.state.user.filters)
			{
				//Loop and build
				for (var i = this.$store.state.user.filters.length - 1; i >= 0; i--)
				{
					//Only add the incidents
					if(this.$store.state.user.filters[i].asset_type == 'Incident')
					{
						filters.push(this.$store.state.user.filters[i]);
					}
				}
			}

			//Send it
			return filters;
		},

		inspectionFilters(){
			//Setup
			var filters = [];

			//Check the stor
			if(this.$store.state.user.filters)
			{
				//Loop and build
				for (var i = this.$store.state.user.filters.length - 1; i >= 0; i--)
				{
					//Only add the incidents
					if(this.$store.state.user.filters[i].asset_type == 'Inspection' && this.$store.state.user.filters[i].pin_to_sidebar == 1)
					{
						filters.push(this.$store.state.user.filters[i]);
					}
				}
			}

			//Send it
			return filters;
		},

		safetyMeetingFilters(){
			//Setup
			var filters = [];

			//Check the stor
			if(this.$store.state.user.filters)
			{
				//Loop and build
				for (var i = this.$store.state.user.filters.length - 1; i >= 0; i--)
				{
					//Only add the incidents
					if(this.$store.state.user.filters[i].asset_type == 'SafetyMeeting')
					{
						filters.push(this.$store.state.user.filters[i]);
					}
				}
			}

			//Send it
			return filters;
		},

		correctiveActionFilters(){
			//Setup
			var filters = [];

			//Check the stor
			if(this.$store.state.user.filters)
			{
				//Loop and build
				for (var i = this.$store.state.user.filters.length - 1; i >= 0; i--)
				{
					//Only add the incidents
					if(this.$store.state.user.filters[i].asset_type == 'CorrectiveAction')
					{
						filters.push(this.$store.state.user.filters[i]);
					}
				}
			}

			//Send it
			return filters;
		},
	},

	methods: {
		shadeColor2(color, percent) {
			var f=parseInt(color.slice(1),16),t=percent<0?0:255,p=percent<0?percent*-1:percent,R=f>>16,G=f>>8&0x00FF,B=f&0x0000FF;
			return "#"+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1);
		},

		isMenuActive (url) {
			return this.$route.path.indexOf(url) === 0
		},

		isMenuOpen (url) {
			return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
		},

		isMenuActiveMultiple (urls) {
			var is_active = false;
			for(let url of urls)
			{
				is_active = is_active || (this.$route.path.indexOf(url) === 0);
			}
			return is_active
		},

		isMenuOpenMultiple (urls) {
			if (this.orientation === 'horizontal')
				return false;

			var is_active = false;
			for(let url of urls)
			{
				is_active = is_active || (this.$route.path.indexOf(url) === 0);
			}
			return is_active
		},

		toggleSidenav () {
			this.layoutHelpers.toggleCollapsed()
		},

		isJsaActive () {
			//Setup
			var exact = (this.$route.path.indexOf('jsa') !== -1 && this.$route.path.indexOf('template') === -1);

			//Send it
			return !exact;
		},
	}
}
</script>

<style>
    .sidenav-custom {
        background-color: var(--backgroundColor) !important; /* most of the background */
        color: var(--noticeColor); /* unused? */
    }

    .sidenav-custom .sidenav-link,
    .sidenav-custom .sidenav-horizontal-prev,
    .sidenav-custom .sidenav-horizontal-next {
        color: var(--textColor); /* most text */
    }

    .sidenav-custom .sidenav-horizontal-next.active {
        color: var(--noticeColor); /* unused? */
    }

    .sidenav-custom .sidenav-inner > .sidenav-item .sidenav-link:hover {
        color: var(--activeTextColor); /* hovered text */
    }

    .sidenav-custom .layout-sidenav-toggle:hover {
        color: var(--activeTextColor); /* hovered text */
    }

    .sidenav-custom .sidenav-item.disabled .sidenav-link,
    .sidenav-custom .sidenav-horizontal-prev.disabled,
    .sidenav-custom .sidenav-horizontal-next.disabled {
        color: var(--noticeColor) !important; /* unused? */
    }

    .sidenav-custom .sidenav-item.open:not(.sidenav-item-closing) > .sidenav-toggle,
    .sidenav-custom .sidenav-item.active > .sidenav-link {
        color: var(--activeTextColor); /* active text */
    }

    .sidenav-custom .sidenav-item.active > .sidenav-link:not(.sidenav-toggle) {
        background-color: var(--activeBackgroundColor); /* active non-toggle background */
    }

    .sidenav-custom &.sidenav-horizontal .sidenav-menu > .sidenav-item.active > .sidenav-link:not(.sidenav-toggle) {
        background-color: var(--noticeColor); /* unused? */
    }

    .sidenav-custom &.sidenav-horizontal .sidenav-inner > .sidenav-item:not(.sidenav-item-closing) > .sidenav-menu,
    .sidenav-custom &.sidenav-horizontal .sidenav-inner > .sidenav-item.open > .sidenav-toggle {
        background: var(--noticeColor); /* unused? */
    }

    .sidenav-custom .sidenav-inner > .sidenav-item.sidenav-item-closing .sidenav-item.open .sidenav-menu,
    .sidenav-custom .sidenav-inner > .sidenav-item.sidenav-item-closing .sidenav-item.open .sidenav-toggle {
        background: transparent;
        color: var(--noticeColor); /* unused? */
    }

    .sidenav-custom .sidenav-text {
        color: var(--activeTextColor); /* title text */
    }

    .sidenav-custom .sidenav-header {
        color: var(--noticeColor); /* unused? */
    }

    .sidenav-custom .sidenav-divider,
    .sidenav-custom .sidenav-inner > .sidenav-item.open > .sidenav-menu::before {
        border-color: var(--activeBackgroundColor) !important; /* hr tags */
    }

    .sidenav-custom .sidenav-inner > .sidenav-header::before,
    .sidenav-custom .sidenav-block::before {
        background-color: var(--noticeColor); /* unused? */
    }

    .sidenav-custom .sidenav-inner > .sidenav-item.open .sidenav-item.open > .sidenav-toggle::before {
        background-color: rgba-to-hex(var(--noticeColor), var(--noticeColor)); /* unused? */
    }

    .sidenav-custom .sidenav-inner > .sidenav-item.open .sidenav-item.active > .sidenav-link::before {
        background-color: var(--noticeColor); /* unused? */
    }

    .sidenav-custom .sidenav-inner > .sidenav-item.open .sidenav-item.open > .sidenav-toggle::before,
    .sidenav-custom .sidenav-inner > .sidenav-item.open .sidenav-item.active > .sidenav-link::before {
        box-shadow: 0 0 0 2px var(--noticeColor); /* unused? */
    }
</style>
